import UnitedState from "@/types/State.interface"

interface State {
    states: UnitedState[]
}

const defaults = () => {
    return {
        states: null
    }
}

export default {
    state: defaults(),
    mutations: {
        statesReset (state: State): void {
            Object.assign(state, defaults())
        },
        statesSet (state: State, states: UnitedState[]): void {
            state.states = states
        },
    },
    actions: {},
    getters: {
        states (state: State): UnitedState[] {
            return state.states
        },
        stateAbrvs (state: State): string[] {
            //  Map all of our states
            return state.states.map((x: UnitedState) => x.stabrv)
        }
    }
}
